"use client";

import { DialogTitle } from "@/components/ui/dialog";
import type { JobListing } from "@/utils/jobsPublic";
import { jobTypeLabel } from "@/utils/jobsPublic";

function LocationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={16}
      height={16}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden
    >
      <path d="M12 21s7-4.35 7-11a7 7 0 1 0-14 0c0 6.65 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  );
}

type ApplicationJobHeaderProps = {
  job: JobListing;
};

export default function ApplicationJobHeader({
  job,
}: Readonly<ApplicationJobHeaderProps>) {
  return (
    <div className="border-b px-6 py-6 sm:px-8 sm:py-8 bg-marketing-voice-card border-black/10">
      <span className="inline-flex w-fit rounded-full px-3 py-1 text-xs font-bold tracking-wide font-monument uppercase bg-gail-primary-light text-gail-primary">
        {job.departmentLabel ?? jobTypeLabel(job.type)}
      </span>
      <DialogTitle className="mt-4 max-w-4xl font-monument text-2xl leading-tight tracking-tight text-foreground md:text-3xl font-normal">
        {job.title}
      </DialogTitle>
      {(job.location || job.compensation) && (
        <div className="mt-4 flex flex-wrap gap-3 text-sm text-black/60">
          {job.location ? (
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 border border-black/10">
              <LocationIcon />
              {job.location}
            </span>
          ) : null}
          {job.compensation ? (
            <span className="inline-flex rounded-full bg-white px-3 py-1.5 border border-black/10">
              {job.compensation}
            </span>
          ) : null}
        </div>
      )}
    </div>
  );
}
